Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveTypesList = exports.resolveType = void 0;
const graphql_1 = require("graphql");
const parseNative_1 = require("./parseNative");
const index_1 = require("../../../../index");
const interfaceTypeRegistry_1 = require("../../../../domains/interfaceType/interfaceTypeRegistry");
function isNativeClass(thing) {
    return (typeof thing === 'function' &&
        thing.hasOwnProperty('prototype') &&
        !thing.hasOwnProperty('arguments'));
}
/**
 * @param input is a type provided in the decorator config
 */
function resolveType(input, allowThunk = true, isArgument = false) {
    if (graphql_1.isType(input)) {
        return input;
    }
    if (parseNative_1.isParsableScalar(input)) {
        return parseNative_1.parseNativeTypeToGraphQL(input);
    }
    if (Array.isArray(input)) {
        return resolveListType(input, isArgument);
    }
    if (index_1.enumsRegistry.has(input)) {
        return index_1.enumsRegistry.get(input);
    }
    if (index_1.unionRegistry.has(input)) {
        return index_1.unionRegistry.get(input)();
    }
    if (interfaceTypeRegistry_1.interfaceTypeRegistry.has(input)) {
        return interfaceTypeRegistry_1.interfaceTypeRegistry.get(input)();
    }
    if (isArgument && index_1.inputObjectTypeRegistry.has(input)) {
        return index_1.compileInputObjectType(input);
    }
    if (index_1.objectTypeRegistry.has(input)) {
        return index_1.compileObjectType(input);
    }
    if (input === Promise ||
        input === Object || // "any" gets inferred as Object by reflect-metadata
        !allowThunk ||
        typeof input !== 'function') {
        return;
    }
    if (isNativeClass(input)) {
        throw new Error(`Class ${input.name} cannot be used as a resolve type because it is not an @ObjectType`);
    }
    return resolveType(input(), false, isArgument);
}
exports.resolveType = resolveType;
function resolveListType(input, isArgument) {
    if (input.length !== 1) {
        return;
    }
    const [itemType] = input;
    const resolvedItemType = resolveType(itemType, true, isArgument);
    if (!resolvedItemType) {
        return;
    }
    return new graphql_1.GraphQLList(new graphql_1.GraphQLNonNull(resolvedItemType));
}
function resolveTypesList(types) {
    if (Array.isArray(types)) {
        return types.map((type) => {
            return resolveType(type);
        });
    }
    return types().map((type) => {
        return resolveType(type);
    });
}
exports.resolveTypesList = resolveTypesList;
//# sourceMappingURL=typeResolvers.js.map